/** @jsx jsx */

export default function FilesSection() {
  // This isn't part of the Vinomed site
  return null;
}
